import React, { Fragment } from 'react'
import { useTracking } from 'react-tracking'
import PropTypes from 'prop-types'

import Link from '../../atoms/Link'
import ApartmentCard from '../../atoms/ApartmentCardVersion2/Container'
import Body from '../../atoms/ApartmentCardVersion2/Body'
import Heading from '../../atoms/ApartmentCardVersion2/Heading'
import Address from '../../atoms/ApartmentCardVersion2/Address'
import SpecialTag from '../../atoms/ApartmentCardVersion2/SpecialTag'
import ApartmentDetailsContainer from '../../atoms/ApartmentCardVersion2/ApartmentDetailsContainer'
import ApartmentTitleContainer from '../../atoms/ApartmentCardVersion2/ApartmentTitleContainer'

import Image from '../../molecules/ApartmentCardVersion2/Image'
import AmenityList from '../../molecules/ApartmentCardVersion2/AmenityList'
import PriceSummary from '../../molecules/ApartmentCardVersion2/PriceSummary'
import ImageContainer from '../../molecules/ApartmentCardVersion2/ImageContainer'

import ApartmentCardVersion1 from '../ApartmentCard'
import ImageCarousel from '../ImageCarousel'

const CardVersion2 = props => {
  const { Track } = useTracking({ apartment: props.name, position: props.position }, {
    dispatchOnMount: () => ({ category: 'Impression', event: 'Apartment Card View', label: '' }),
  })

  const {
    version,
    isGrid,
    marketingWebsiteUrl,
    name: title,
    address: { line1, city, state },
    termGroups: amenities,
    adLabel: specialTag,
    priceSummary,
  } = props
  const carousel = props.tour && props.tour.length > 0
    ? props.tour
    : (props.carousel || [props.defaultPhoto])

  const hasAmenities = !!amenities.length

  const openWebsite = () => {
    if (carousel.length === 1) {
      window.open(marketingWebsiteUrl, '_blank')
    }
  }

  const version1Props = {
    ...props,
    carousel,
    specialTag,
    openWebsite,
  }

  return version === 1 ? (
    <ApartmentCardVersion1 {...version1Props } />
  ) : (
    <Track>
      <ApartmentCard isGrid={isGrid}>
        <ImageCarousel style={isGrid ? {} : { maxWidth: 290, height: '100%' }}>
          {carousel.map(({ url: imageSrc, alt }, index) =>
            <ImageContainer key={index} isGrid={isGrid} onClick={openWebsite}>
              <Image src={imageSrc} alt={alt} />
              {specialTag ? <SpecialTag>{specialTag}</SpecialTag> : null}
            </ImageContainer>
          )}
        </ImageCarousel>
        <Body as={Link} href={marketingWebsiteUrl} isGrid={isGrid} target='_blank'>
          {isGrid ? (
            <Fragment>
              <Heading as='h3'>{title}</Heading>
              <Address>{`${line1}, ${city}, ${state}`}</Address>
              {hasAmenities ? <AmenityList amenities={amenities} isGrid={isGrid} max={8} /> : null}
              <PriceSummary isGrid={isGrid} priceSummary={priceSummary} hasAmenities={hasAmenities} />
            </Fragment>
          ) : (
            <ApartmentDetailsContainer>
              <ApartmentTitleContainer isGrid={isGrid}>
                {/* TODO: Make it a single component */}
                <div>
                  <Heading as='h3'>{title}</Heading>
                  <Address>{`${line1}, ${city}, ${state}`}</Address>
                </div>
                <PriceSummary isGrid={isGrid} priceSummary={priceSummary} />
              </ApartmentTitleContainer>
              {hasAmenities ? <AmenityList amenities={amenities} isGrid={isGrid} /> : null}
            </ApartmentDetailsContainer>
          )}
        </Body>
      </ApartmentCard>
    </Track>
  )
}

CardVersion2.defaultProps = {
  isGrid: true,
}

CardVersion2.propTypes = {
  isGrid: PropTypes.bool.isRequired,
  marketingWebsiteUrl: PropTypes.string.isRequired,
  defaultPhoto: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  name: PropTypes.string.isRequired,
  address: PropTypes.shape({
    line1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
  }).isRequired,
  termsGroups: PropTypes.arrayOf(PropTypes.object),
  priceSummary: PropTypes.arrayOf(PropTypes.object).isRequired,
  specialTag: PropTypes.string,
}

export default CardVersion2
